require('angular').module('oly.common')
    .factory('ResourceInjector', ['$q', require('./resource-injector-factory')]);



// WEBPACK FOOTER //
// ./src/olycommon/resources/index.js